//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { loadAppForm } from "./utils/wxapp-check";

export default {
  name: "app",
  data() {
    return {
      showHeader: true,
      mask: false,
      popping: false,
      showFooter: false,
    };
  },
  mounted() {
    loadAppForm();
  },
  methods: {
    header(bool) {
      this.showHeader = bool;
    },
    close() {
      this._mask();
    },
    pop() {
      //window.open('http://ekp.mingyuanyun.com/Opportunities/Pages/ActivityForm.aspx?ActivityGUID=76389eb7-b3a5-4335-a224-9dfb16d13481&Channel=1',"_self")
      var ekpClueH5Url = document
        .querySelector('meta[name="ekpClueH5Url"]')
        .getAttribute("content");
      if (ekpClueH5Url && ekpClueH5Url.length > 0) {
        var arr = ekpClueH5Url.split("/");
        if (arr.length > 2) {
          this.$router.push({
            name: "Opport",
            params: {
              activity_id: arr[arr.length - 2],
              channel: arr[arr.length - 1],
            },
          });
        }
      }
    },
    _mask() {
      this.mask = false;
      this.popping = false;
    },
    _footer(bool) {
      this.showFooter = bool;
    },
  },
  watch: {
    $route: function (to, from) {
      if (to.hash) {
        let timer = null;
        timer = setInterval(() => {
          if (document.querySelector(to.hash)) {
            clearInterval(timer);
            document.querySelector(to.hash).scrollIntoView();
          }
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/App.vue